import {download, get} from "@/utils/http";

export const _getSelectPages = params => get("/batchOutputLog/selectPages", params);
export const getDownload = (params,headerconfig,downloadProgress,downloadAfterHandle)=>download("/batchOutputLog/download",params,headerconfig,downloadProgress,downloadAfterHandle)

